




































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import DateUtils from '@/common/js/DateUtils'
import CreateExpressRejection from './express-applyrejection.vue'
import storeaddressInfo from '@/store/entities/back-storeaddress-list'
import CreateExpressReturn from './express-applyreturn.vue'
import ImageStandard from './ImageStandard.vue'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(Preview);

class PageExpressRejectionsRequest extends PageRequest {
    shipment: string;
    beginTime?: Date;
    endTime?: Date;
    handleType?: number;
    handleStatus?: number;
    whetherAbroad?: boolean;
    storeId?: number;
    constructor() {
        super();
        this.handleType = null;
        this.handleStatus = null;
    }
}

@Component
    ({
        name:"expressrejectionreturn",
        components: { CreateExpressRejection, CreateExpressReturn, ImageStandard }
    })
export default class ExpressRejection extends AbpBase {
    handleStatus = Enums.getEnum(Enums.HandleStatus, true);
    handleType = Enums.getEnum(Enums.HandleType, true);
    pagerequest: PageExpressRejectionsRequest = new PageExpressRejectionsRequest();
    applyModalShow: boolean = false;
    applyReturnModalShow: boolean = false;
    storeaddressList: Array<storeaddressInfo> = [];
    whetherAbroadList = Enums.getEnum(Enums.WhetherAbroadStatus, true);
    imageStandardModalShow: boolean = false;
    isDisplay: boolean = false;
    creationTime: Date[] = [];
    revokedTime: Date[] = [];
    rejectionTime: Date[] = [];
    get list() {
        return this.$store.state.expressrejectioninfo.list;
    };
    get loading() {
        return this.$store.state.expressrejectioninfo.loading;
    }
    pageChange(page: number) {
        this.$store.commit('expressrejectioninfo/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('expressrejectioninfo/setPageSize', pagesize);
        this.getpage();
    }
    applyrejection() {
        this.applyModalShow = true;
    }
    applyreturn() {
        this.applyReturnModalShow = true;
    }
    async searchPage() {
        this.$store.state.expressrejectioninfo.currentPage=1;
        this.getpage();
    }
    async getpage() {

        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        if (this.creationTime.length > 0) {
            this.pagerequest.beginTime = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endTime = this.creationTime[1];
        }

        await this.$store.dispatch({
            type: 'expressrejectioninfo/getAll',
            data: this.pagerequest
        })
    }
    imageCheck() {
        this.imageStandardModalShow = true;
    }
    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        this.storeaddressList.push(a);

    }

    changestatus(a: any) {
        this.pagerequest.storeId = null;
        if (a == true) {
            this.getData();
            this.isDisplay = true;
        }
        else {
            this.isDisplay = false;
        }
    }
    get pageSize() {
        return this.$store.state.expressrejectioninfo.pageSize;
    }
    get totalCount() {
        return this.$store.state.expressrejectioninfo.totalCount;
    }
    get currentPage() {
        return this.$store.state.expressrejectioninfo.currentPage;
    }
    async operationData(name: any, data: any) {
        if (name == '撤销') {
            await this.$store.dispatch({
                type: 'expressrejectioninfo/editRevoked',
                data: { Id: data.id, HandleStatus: data.handleStatus }
            });

            //this.editModalShow = true;
        }
        var _this: any = this;
        _this.$previewRefresh();
        this.getpage();
    }
    columns = [{
        title: '快递处理类型',
        width: 120,
        fixed: 'left',
        key: 'handleType',
        render: (h: any, params: any) => {
            return h('span', Enums.HandleType.filter(function (item) { return item.value == params.row.handleType })[0].name);
        }
    }, {
        title: '快递单号',
        key: 'shipment',
        width: 150,
        },
        {
            title: '扣费状态',
            width: 120,
            key: 'deductionType',
            render: (h: any, params: any) => {
                if (params.row.handleStatus == 1) {
                    return h('span', Enums.DeductionType.filter(function (item) { return item.value == params.row.deductionType })[0].name);
                }
                else {
                    return h('span', "");
                }

            }
        }, {
        title: '处理备注',
        key: 'processReMark',
        width: 150,
        }, {
        title: '仓库名称',
        key: 'warehouseName',
            width: 200,
            render: (h: any, params: any) => {
                return h('span', params.row.warehouseName ? params.row.warehouseName : params.row.storeName);
            }
    }, {
        title: '快递公司',
        key: 'expressCompany',
        width: 150,
        },
        {
            title: '收件人',
            key: 'recipientName',
            width: 150,
        },
        {
            title: '固话',
            key: 'receiptPhone',
            width: 150,
        },
        {
            title: '手机号',
            key: 'phone',
            width: 150,
        },
        {
            title: '收货地址',
            key: 'receiptAddress',
            width: 150,
        },
        {
        title: '收件人信息',
        key: 'recipientInfo',
        width: 250,
    }, {
        title: '备注',
        width: 250,
        key: 'reMark',
    }, {
        title: '退货快递公司',
        key: 'returnExpressCompany',
        width: 150,
    }, {
        title: '退货单号',
        key: 'returnNo',
        width: 150,
    }, {
        title: '快递费',
        key: 'expressCost',
        width: 150,
    }, {
        title: '创建时间',
        key: 'createTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
        }
    }, {
        title: '撤销时间',
        key: 'revokedTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.revokedTime ? DateUtils.formatLongDate(new Date(params.row.revokedTime)) : '');
        }
    }, {
        title: '拒收时间',
        key: 'rejectionTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.rejectionTime ? DateUtils.formatLongDate(new Date(params.row.rejectionTime)) : '');
        }
    }, {
        title: '退货时间',
        key: 'returnTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.returnTime ? DateUtils.formatLongDate(new Date(params.row.returnTime)) : '');
        }
    }, {
        title: '快递处理状态',
        width: 120,
        key: 'handleStatus',
        fixed: 'left',
        render: (h: any, params: any) => {
            return h('span', Enums.HandleStatus.filter(function (item) { return item.value == params.row.handleStatus })[0].name);
        }
    }, {
        title: '操作',
        width: 100,
        fixed: 'right',
        key: 'id',
        render: (h: any, params: any) => {
            var _this = this;
            var menu = [];
            if (Enums.HandleStatus.filter(function (item) { return item.value == params.row.handleStatus })[0].name == "待处理") {
                menu.push("撤销");
            }
            return h('Dropdown', {
                props: {
                    transfer: true,
                    trigger: 'click',
                },
                on: {
                    'on-click': (name) => {
                        _this.operationData(name, params.row);
                    }
                }

            }, [
                h('Button',
                    {
                        domProps: {
                            innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                        },
                        props: {
                            type: 'primary',
                        }

                    }),
                h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                    return h('DropdownItem', { props: { name: item } }, item)
                })
                )]);
        }
    }]
    async created() {
        this.getpage();
        this.getData();
    }
}
